import { GridCallbackDetails, GridSortModel } from "@mui/x-data-grid-pro";
import { OrderByDirection, OrderByItem } from "../../../graphql/generated";

export const gridSortModelToApiOrderBy = (
  model: GridSortModel,
  details: GridCallbackDetails<any>
): OrderByItem[] => {
  return model
    .map((sortItem) => {
      const column = details.api.getColumn(sortItem.field);
      // Column can be missing when the sort model references a field that was
      // removed (e.g. tab/column config change) or is not yet registered.
      if (!column) {
        return null;
      }
      return {
        field: String(column.cellClassName || column.field),
        direction:
          sortItem.sort === "desc"
            ? OrderByDirection.Desc
            : OrderByDirection.Asc,
      };
    })
    .filter((item): item is OrderByItem => item !== null);
};
